module.exports = __webpack_public_path__ + "media/images/massage/cover-mobile@2x-3b2b80cb21dd5b77db9151d2cf71e6a1.jpg";